// actions
import audienceId from '@/store/actions/audienceId'
import slideOptions from '@/store/actions/slideOptions'
import slides from '@/store/actions/slides'
import presentation from '@/store/actions/presentation'
import currentUser from '@/store/actions/currentUser'
import privateFeedback from '@/store/actions/privateFeedback'
import attendedPresentation from '@/store/actions/attendedPresentation'
import common from '@/store/actions/common'
import uploadLog from '@/store/actions/uploadLog'
import i18n from '@/i18n'
import { getPresentingLanguageFromCdn } from '@/utils/language'
import counting from '@/store/actions/counting'

export default {
  ...audienceId,
  ...slideOptions,
  ...slides,
  ...presentation,
  ...currentUser,
  ...privateFeedback,
  ...attendedPresentation,
  ...common,
  ...uploadLog,
  ...counting,

  setLang: async (context, payload) => {
    context.commit('setLang', payload)
    // code br cũ đang sai đã update presenter thành pt, để các presentation cũ vẫn hoạt động cần switch br thành pt
    // TODO: xoá logic này khi code br được thêm vào lại (nếu có)
    if (payload === 'br') {
      payload = 'pt'
    }
    const data = await getPresentingLanguageFromCdn(payload)
    if (data) {
      i18n.setLocaleMessage(payload, data)
    }
  },

  setSlide: ({ commit }, payload) => {
    if (!payload) return

    commit('setSlide', payload)
    commit('setSlideV2', payload)
  },

  // Update Presentation
  updateSlide: (context, payload) => {
    context.commit('updateSlide', payload)
    context.commit('updateSlideV2', payload)
  },

  // Update Presentation
  setConnectionError: (context, payload) => {
    context.commit('setConnectionError', payload)
  },

  setUserLoaded: (context, payload) => {
    context.commit('setUserLoaded', payload)
  },

  setIsLoadingCurrentUserAction: (context, payload) => {
    context.commit('setIsLoadingCurrentUser', payload)
  },
}
